import React, { useContext } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { techappContext } from "../../../Api/techappReq";
import { setTicketData } from "../../../Redux/Actions/TechAppAction";
import Colors from "../../../Helper/Colors";
// import lang from "../lang/lang.json";
import { toast } from "react-toastify";

const TicketCard = ({ ticket, index }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { ticketComments } = useContext(techappContext);

  const openTicket = (index, id) => {
    dispatch(setTicketData(index));
    navigate("/techapp/view-ticket");
    ticketComments(id);
  };

  return (
    <div
      key={index}
      onClick={() => {
        if (!localStorage.getItem("auth_from_admin")) {
          openTicket(ticket, ticket.id);
        } else {
          toast.error("شما از پنل ادمین وارد شده اید و دسترسی ندارید.");
        }
      }}
      className={`techapp-ticket-item ${
        ticket.readed === true ? "readed" : ""
      }`}
      style={
        ticket.state === "تیکت جدید"
          ? { border: "1px solid #fcc603" }
          : { border: "1px solid rgb(200,200,200)" }
      }
      id={`ticket_item_${index}`}
    >
      {/* title */}
      <span className="techapp-ticket-item-title techapp-tickets-ticket-item-title">
        {ticket.title}
      </span>
      {/* content */}
      <span className="techapp-ticket-item-text">
        {ticket?.message?.length > 30
          ? ticket?.message?.substring(0, 30) + "..."
          : ticket?.message}
      </span>
      {/* status */}
      {ticket.state === "در انتظار پاسخ" && (
        <div
          className="techapp-ticket-waiting-mark"
          style={{ backgroundColor: Colors.warning }}
        >
          <span style={{ color: "black" }}>{ticket.state}</span>
        </div>
      )}
      {ticket.state === "تیکت جدید" && (
        <div
          className="techapp-ticket-waiting-mark"
          style={{
            backgroundColor: Colors.royalBlue,
          }}
        >
          <span style={{ color: "white" }}>{ticket.state}</span>
        </div>
      )}
      {ticket.state === "پاسخ جدید" && (
        <div
          className="techapp-ticket-waiting-mark"
          style={{ backgroundColor: "red" }}
        >
          <span style={{ color: "white" }}>{ticket.state}</span>
        </div>
      )}
      {ticket.state !== "پاسخ جدید" &&
        ticket.state !== "تیکت جدید" &&
        ticket.state !== "در انتظار پاسخ" && (
          <div
            className="techapp-ticket-waiting-mark"
            style={{ backgroundColor: "rgb(210, 210, 210)" }}
          >
            <span style={{ color: "black" }}>{ticket.state}</span>
          </div>
        )}
    </div>
  );
};
export default TicketCard;
